export class ResetPassword {
  public userId: string;
  public token: string;
  public newPassword: string;
  constructor() {
    this.userId = '';
    this.token = '';
    this.newPassword = '';
  }
}

export class ResetPasswordModel {
  ResetPassword: ResetPassword;
  EndPointURL: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/resetpassword/resetpassword.ts